<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
/* eslint-disable no-undef */
// import api from '../api/index.js'
export default {
  name: 'App',
  data () {
    return {
    }
  },
  mounted () {
    /* api.getWeixinConfig().then(res => {
      // console.log(res)
    }) */
  }
}
</script>

<style lang="scss">
html, body{
  height: 100%;
  padding: 0;
  margin: 0;
}
#app {
  height: 100%;
}
.h5--page {
  background: #f4f5f6;
  width: 7.5rem;
  margin: 0 auto;
  min-height: 100vh;
}
.tips-txt {
  color: #83889a;
}
</style>
